<template>
  <v-layout justify-center>
    <v-card max-width="400">
      <v-card-text>
        <v-text-field label="key" v-model="key"></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="login">Login</v-btn>
      </v-card-actions>
    </v-card>
  </v-layout>
</template>

<script>
  import router from '../router'
  import {mapActions} from 'vuex';

  export default {
    name: 'Login',
    data() {
      return {
        key: ''
      }
    },
      methods: {
        ...mapActions(['updateApiKey']),
      login() {
        if (this.key != '') {
          this.updateApiKey(this.key);
          router.push(router.history.current.query.redirect || '/');
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Login.vue